import React, { useContext, useState } from "react";
import { LabelProps } from "../../../../../../utils/types";
import SuppliersSelect from "../../purchaseorder/rfqtopo/components/SuppliersSelect";
import { StockEntryContext } from "./context/context";
import {
  responseType,
  SupplierFormState,
} from "../../../../../../utils/formTypes";
import { stockEntryPayLoadTypes } from "./context/reducer";
import { TextField } from "@mui/material";
import useLabels from "../../../../../../customHooks/useLabels";
import useFormJson from "../../../../../../json/useFormJson";
import { LdgrQueryType } from "../../../masters/supplier/queries/types";

const SupplierForm = () => {
  const { dispatch, state } = useContext(StockEntryContext);
  const { StockEntry } = useFormJson();
  const initialState: SupplierFormState = {
    supplier_ref_no: "",
    supplied_date: "",
    supplied_qty: "",
    supplied_rate: "",
  };

  const [formState, setFormState] = useState<SupplierFormState>(initialState);

  const onSupplierSelect = (newValue: responseType) => {
    if (newValue) {
      dispatch({
        type: stockEntryPayLoadTypes.SUPPLIER,
        payload: {
          supplier: newValue,
        },
      });
    } else {
      dispatch({
        type: stockEntryPayLoadTypes.SUPPLIER,
        payload: {
          supplier: null,
        },
      });
    }
  };
  const { ledgerLabel } = useLabels();
  return (
    <div className="col add-stock-entry__select--grid">
      {StockEntry.WithoutPurchase.SupplierDetails.map(
        (label: LabelProps, index: React.Key) => {
          if (label.inputName === "supplier") {
            return (
              <div className="add-stock-entry__select--flex" key={index}>
                <SuppliersSelect
                  onChange={onSupplierSelect}
                  value={state.supplier ? state.supplier.value : 0}
                  label={`Select ${ledgerLabel}`}
                  icon={true}
                  input={{
                    query_type: LdgrQueryType.ALL,
                    itemID: 0,
                    tableLevel: undefined,
                  }}
                />
              </div>
            );
          } else
            return (
              <React.Fragment key={index}>
                <TextField
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  label={label.labelName}
                  className="add-stock-entry__select--textfield"
                  disabled
                />
              </React.Fragment>
            );
        }
      )}
    </div>
  );
};

export default SupplierForm;
